export default __webpack_public_path__ + "static/media/DJ.0516ae61.svg";